// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpApIlogIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpApIlogIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpApIlogIconOutlined = function DrrpApIlogIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpApIlogIconOutlinedSvg
  }));
};

DrrpApIlogIconOutlined.displayName = 'DrrpApIlogIconOutlined';
export default React.forwardRef(DrrpApIlogIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpApIlogIconOutlined.js
// module id = 2487
// module chunks = 0